module.exports = __webpack_public_path__ + "static/media/23.0602815d.mp3";